<app-report-controller
  #pieChart
  chartId="session-time-frequency"
  [chartType]="[donutChartType]"
  yAxisLabel="Session frequency"
  [colorPalette]="chartColors"
  [tooltipTrigger]="'item'"
  [limitDataPresentation]="5"
  [isSqlRequest]="true"
  [reportFiltersetId]="reportFiltersetId"
  [sqlRequestParams]="{
    report: 'sessionTimeFrequency',
    filters: timeFrequencyFilters
  }"
  (chartOptionOutput)="setSessionCounts($event)">
  <app-frequency-table
    [filters]="defaultFilters"
    [reportFiltersetId]="reportFiltersetId"
    [colors]="chartColors"
    [externalData]="sessionCounts"></app-frequency-table>
</app-report-controller>
